import {RemoteConstantsModel} from "../models/remoteConstants.model";

export abstract class CommandBase {
    abstract execute(data: RemoteConstantsModel): boolean;
}